export var ShopThumbType;
(function(ShopThumbType) {
    ShopThumbType["PCP"] = "pcp";
    ShopThumbType["COMMISSION"] = "commission";
})(ShopThumbType || (ShopThumbType = {}));

//# sourceMappingURL=types.js.map